import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

// "Tomorrow might be a harder day" card with a quick note box (no reasons or mood numbers shown)
export const SupporterForecastNote = ({ token, name }) => {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  useEffect(() => { api.get(`/supporters/view/${token}/forecast`).then((r) => setD(r.data)).catch((e) => logError("Forecast load failed:", e)); }, [token]);
  useEffect(() => { if (d?.show && window.location.hash === "#forecast-note") document.getElementById("forecast-note")?.scrollIntoView({ behavior: "smooth", block: "center" }); }, [d]);
  if (!d?.show) return null;
  const send = async () => {
    setBusy(true);
    try { await api.post(`/supporters/view/${token}/note`, { message: msg.trim() }); setSent(true); toast.success(`Note sent to ${name} 💌`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div id="forecast-note" className="mm-card p-5 mm-fade-up" data-testid="supporter-forecast-note">
      <div className="flex items-start gap-3">
        <div className="text-3xl" aria-hidden>☁️</div>
        <div className="flex-1">
          <div className="font-semibold text-lg" data-testid="supporter-forecast-title">Tomorrow ({d.weekday}) might be a harder day for {name}</div>
          <p className="text-sm text-mm-muted">A few kind words tonight could help them start the day feeling less alone.</p>
        </div>
      </div>
      {sent ? <p className="mt-3 text-sm font-semibold text-mm-primary" data-testid="supporter-forecast-sent">💌 Note sent. Thank you for thinking of them.</p> : <>
        <textarea value={msg} onChange={(e) => setMsg(e.target.value.slice(0, 500))} rows={3} placeholder={`Thinking of you, ${name}. Here if you need me tomorrow 💜`} className="mm-input w-full mt-3" data-testid="supporter-forecast-input" />
        <button onClick={send} disabled={busy || !msg.trim()} className="mm-btn mt-2" data-testid="supporter-forecast-send">{busy && <Loader2 size={16} className="animate-spin" />}Send note</button>
      </>}
    </div>
  );
};
